<template>
  <div class="full-height-16">
    <div class="full-height" v-show="showList">
      <div class="header">
        <el-form ref="form" :model="form" :inline="true"  class="form-inline" size="mini">
          <el-form-item label="广告标题">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" size="mini">查询</el-button>
            <el-button type="primary"  size="mini" @click="updateRow">新增</el-button>
            <el-button type="primary"  size="mini" @click="batchCheck()">批量申请审核</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <el-table
          :data="tableData"
          v-loading="tableLoading"
          style="width: 100%"
          max-height="500"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
          >
          <el-table-column
            type="selection"
            width="55">
            </el-table-column>
          <el-table-column
            prop="advertiseTypeLabel"
            label="广告类型">
          </el-table-column>
          <el-table-column
            prop="name"
            label="广告标题">
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="有效开始日期">
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="有效结束日期">
          </el-table-column>
          <el-table-column
            prop="statusLabel"
            label="状态">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="lookAd(scope.row)" type="text" size="small">查看</el-button>
              <!--<el-button @click.native.prevent="lookAd(scope.row)" type="text" size="small">预览</el-button>-->
              <el-button @click.native.prevent="updateRow(scope.$index)" type="text" size="small" v-if="scope.row.status==1 || scope.row.status==6 || scope.row.status==7">修改</el-button>
              <el-button @click.native.prevent="revoke(scope.$index)" type="text" size="small" v-if="scope.row.status!=1 && scope.row.status!=5">撤回</el-button>
              <el-button @click.native.prevent="applyCheck(scope.$index)" type="text" size="small" v-if="scope.row.status==1">申请审核</el-button>
              <el-button @click.native.prevent="applyCheck(scope.$index)" type="text" size="small" v-if="scope.row.status==7">重新申请</el-button>
              <el-button @click.native.prevent="off(scope.$index)" type="text" size="small" v-if="scope.row.status==5">下架</el-button>
              <el-button @click.native.prevent="checkRecord(scope.row)" type="text" size="small">审批记录</el-button>
              <el-button @click.native.prevent="deleteRow(scope.$index)" type="text" size="small" v-if="scope.row.status!=4 && scope.row.status!=5">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 100]"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="full-height" v-show="showUpdate">
      <add-ad :add-info="editForm" v-on:save="onSubmit('editForm')"></add-ad>
    </div>
    <div class="full-height" v-show="showLook">
      <el-form :model="editForm" label-width="100px" :rules="rules" ref="editForm" class="formPage" size="mini">
        <el-form-item label="广告时间">
          <span>{{lookInfo.startTime+' 至 '+lookInfo.endTime}}</span>
        </el-form-item>
        <el-form-item label="广告标题">
          <span>{{lookInfo.name}}</span>
        </el-form-item>
        <el-form-item label="广告类型">
          <span>{{lookInfo.advertiseTypeLabel}}</span>
        </el-form-item>
        <el-form-item label="默认图片">
          <img :src="lookInfo.imgUrl" class="avatar">
        </el-form-item>
        <el-form-item label="H5地址" v-if="lookInfo.advertiseType==1">
          <span>{{lookInfo.linkUrl}}</span>
        </el-form-item>
        <el-form-item label="软文配置" v-if="lookInfo.advertiseType==2">
          <span class="content-box" v-html="lookInfo.softContent"></span>
        </el-form-item>
        <el-form-item>
          <el-button @click="backList">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="审批记录" :visible.sync="dialogTableVisible">
      <el-table :data="gridData" max-height="500">
        <el-table-column fixed type="index" label="序号" width="50px"></el-table-column>
        <el-table-column prop="turnToLabel" label="审批环节" width="200px"></el-table-column>
        <el-table-column prop="dealResultLabel" label="审核状态" ></el-table-column>
        <el-table-column prop="typeLabel" label="审核类型"></el-table-column>
        <el-table-column prop="dealUser" label="审核人"></el-table-column>
        <el-table-column prop="dealAdvise" label="审批意见"></el-table-column>
        <el-table-column prop="createDate" label="审核时间" width="150px"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<style>

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
<script type="es6">
  import E from 'wangeditor'
  export default {
    data() {
      return {
        form: {
          name: '',
          positionId:''
        },
        showList:true,
        showUpdate:false,
        showLook:false,
        positionId:this.$route.path.slice(1),
        open:1,//新增
        currentPage: 1,
        pageSize:20,
        tableLoading:false,
        isDisabled:false,
        tableData: [],
        total:0,
        dialogVisible:false,
        dialogImageUrl:'',
        time:[],
        editForm: {
          name: '',
          advertiseType: '',
          startTime: '',
          endTime: '',
          imgUrl:'',
          linkUrl:'',
          softContent:'',
          id:'',
          positionId:''
        },
        fmPic:this.$api.root+this.$face.Other.fmPic,
        editor:null,
        rules:{
          name:[
            {required:true,message:'请输入广告标题',trigger:'blur'},
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
          ],
          description:[
            {required:true,message:'请输入详情',trigger:'blur'},
            { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
          ],
          imgUrl:[
            {required:true,message:'请选择默认图片',trigger:'change'}
          ],
          advertiseType:[
            {required:true,message:'请输入广告类型',trigger:'blur'}
          ],
          adSupplierId:[
            { required: true, message: '请选择供应商', trigger: 'change' }
          ]
        },
        lookInfo:{
          name: '',
          advertiseTypeLabel: '',
          startTime: '',
          endTime: '',
          imgUrl:'',
          linkUrl:'',
          softContent:'',
          advertiseType:''
        },
        gridData:[],
        dialogTableVisible:false,
        multipleSelection:[],
        checkType:0 //默认0为单独申请审核，1为批量申请审核
      }
    },
    computed:{
      showH5:function(){
        if(this.editForm.advertiseType==1){
          return true
        }else{
          return false
        }
      },
      showContent:function(){
        if(this.editForm.advertiseType==2){
          return true
        }else{
          return false
        }
      }
    },
    watch:{
      $route(){
        this.getList();
      }
    },
    created (){
      this.getList();
      this.$store.dispatch('getAllDics');//获取字典列表
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        if (row['status']==1) {
          return 'success-row';
        }
        return '';
      },
      getTime(dateArr){
        for(var i=0;i<dateArr.length;i++){
          dateArr[i]=this.$fun.formatTime(dateArr[i])
        }
        this.editForm.startTime=dateArr[0];
        this.editForm.endTime=dateArr[1];
      },
      getList (){
        var v=this;
        var param={
          page:this.currentPage,
          rows:this.pageSize,
          name:this.form.name,
          positionId:this.$route.path.slice(1)
        };
        v.tableLoading=true;
        v.$api.post(v.$face.AdInfoUrl.aList, param, function(r) {
          v.tableLoading=false;
          if(r.status){
            v.tableData= r.detail.list;
            v.total= r.detail.total;
          }else{
            v.$face.overdue(r.errorCode,r.userMessage);
          }
        })
      },
      search(){
        if(this.currentPage==1){
          this.getList();
        }else{
          this.currentPage=1;
        }
      },
      handleSelectionChange(val) {
        var v=this;
        v.multipleSelection=val;
        console.log(val);
      },
      batchCheck(){
        var v=this;
        v.checkType=1;
        let ids=[],status=true;
        for(var i=0;i<v.multipleSelection.length;i++){
          if(v.multipleSelection[i]['status']!=1){
            v.$message.error('含其他状态广告，无法批量申请审核');
            status=false;
            break;
          }else{
            ids.push(v.multipleSelection[i]['id'])
          }
        }
        if(!status){
          return false
        }
        if(v.multipleSelection.length<=1){
          v.$message.error('未选择2条(含2条)以上广告');
          return false;
        }else{
          var v=this;
          this.$confirm('确认批量申请审核?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            v.$api.post(v.$face.AdInfoUrl.batchApply, {ids: ids.join(',')}, function(r) {
              if(r.status){
                v.getList();
                v.$message({
                  message: '操作成功',
                  type: 'success'
                });
              }else{
                v.$face.overdue(r.errorCode,r.userMessage);
              }
            })
          }).catch(() => {
          });
        }
      },
      updateRow (index){
        var v=this;
        if(v.$refs.editForm){
          v.$refs.editForm.clearValidate();
        }
        v.isDisabled=false;
        v.showList=false;
        v.showUpdate=true;
        if(index>=0){
          v.editForm['id']='';
          for(var k in v.editForm){
            v.editForm[k]=v.tableData[index][k];
          }
          v.time=[v.editForm.startTime,v.editForm.endTime];
          v.open=2;
        }else{
          delete v.editForm.id;
          for(var k in v.editForm){
            v.editForm[k]='';
          }
          v.open=1;
          v.time=''
        }
        this.createEdit();
      },
      applyCheck(index){
        var v=this;
        this.$confirm('确认申请审核?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          v.$api.post(v.$face.AdInfoUrl.applyCheck, {id: v.tableData[index]['id']}, function(r) {
            if(r.status){
              v.getList();
              v.$message({
                message: '操作成功',
                type: 'success'
              });
            }else{
              v.$face.overdue(r.errorCode,r.userMessage);
            }
          })
        }).catch(() => {
        });
      },
      revoke(index){
        var v=this;
        this.$confirm('确认撤回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          v.$api.post(v.$face.AdInfoUrl.revoke, {id: v.tableData[index]['id']}, function(r) {
            if(r.status){
              v.getList();
              v.$message({
                message: '操作成功',
                type: 'success'
              });
            }else{
              v.$face.overdue(r.errorCode,r.userMessage);
            }
          })
        }).catch(() => {
        });
      },
      off(index){
        var v=this;
        this.$confirm('确认下架?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          v.$api.post(v.$face.AdInfoUrl.off, {id: v.tableData[index]['id']}, function(r) {
            if(r.status){
              v.getList();
              v.$message({
                message: '操作成功',
                type: 'success'
              });
            }else{
              v.$face.overdue(r.errorCode,r.userMessage);
            }
          })
        }).catch(() => {
        });
      },
      deleteRow(index){
        var v=this;
        this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          v.$api.post(v.$face.AdInfoUrl.aDel, {id: v.tableData[index]['id']}, function(r) {
            if(r.status){
              v.getList();
              v.$message({
                message: '删除成功',
                type: 'success'
              });
            }else{
              v.$face.overdue(r.errorCode,r.userMessage);
            }
          })
        }).catch(() => {
        });
      },
      handleSizeChange(val) {
        this.pageSize=val;
        if(this.currentPage==1){
          this.getList();
        }else{
          this.currentPage=1;
        }
      },
      handleCurrentChange(val) {
        this.currentPage=val;
        this.getList();
      },
      handleSuccess(response, file, fileList){
        this.dialogVisible=true;
        this.editForm.imgUrl=response;
      },
      createEdit(){
        var v=this;
        if(v.editor){
          return
        }
        v.editor = new E('#content');
        v.editor.customConfig.uploadImgServer = this.$api.root+this.$face.Other.editPic;
        v.editor.customConfig.uploadImgMaxSize = 1 * 1024 * 1024;
        v.editor.customConfig.uploadImgMaxLength = 5;
        v.editor.customConfig.uploadFileName  = 'file';
        v.editor.create()
      },
      onSubmit(form) {
        var v=this;
        v.isDisabled=true;
        v.$refs[form].validate((valid)=>{
          if(valid){
            var url='';
            if(v.open==1){
              url=v.$face.AdInfoUrl.aSave;
            }else{
              url=v.$face.AdInfoUrl.aUpdate;
            }
            if(v.editForm.advertiseType==1){
              v.editForm.softContent='';
              if(!v.$fun.checkUrl(v.editForm.linkUrl)){
                return false;
              }
            }else{
              v.editForm.linkUrl='';
              v.editForm.softContent=v.editor.txt.html();
              if(!v.$fun.checkEdit(v.editor.txt.text())){
                return false;
              }
            }
            v.editForm.positionId=this.$route.path.slice(1);
            v.$api.post(url, v.editForm, function(r) {
              if(r.status){
                v.$message({
                  message: '操作成功',
                  type: 'success'
                });
                v.backList();
                v.getList();
              }else{
                v.$face.overdue(r.errorCode,r.userMessage);
              }
              v.$refs[form].clearValidate();
              v.isDisabled=false;
            })
          }else{
            v.isDisabled=false;
          }
        })
      },
      backList(){
        this.showList=true;
        this.showUpdate=false;
        this.showLook=false;
      },
      lookAd(item){
        let v=this;
        v.showList=false;
        v.showLook=true;
        for(var k in v.lookInfo){
          v.lookInfo[k]=item[k];
        }
      },
      checkRecord(info){
        let v=this;
        v.dialogTableVisible=true;
        v.$api.post(v.$face.AdInfoUrl.checkRecord, {advertId:info.id}, function(r) {
          if(r.status){
            v.gridData=r.list;
          }else{
            v.$face.overdue(r.errorCode,r.userMessage);
          }
        })
      }
    }
  }
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/adPut/start_page.vue


// WEBPACK FOOTER //
// src/pages/adPut/start_page.vue